import axios from "axios";

export const API_BASE_URL =
  process.env.REACT_APP_API_URL || "https://mailsign.alpha.family";
console.log("API_BASE_URL: ", API_BASE_URL);

export const api = {
  // Авторизация через Яндекс
  yandexLogin: () => {
    window.location.href = `${API_BASE_URL}/api/auth/yandex`;
  },

  // Загрузка изображения
  uploadImage: async (file) => {
    const formData = new FormData();
    formData.append("file", file);

    const response = await axios.post(`${API_BASE_URL}/api/upload`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    const url = response?.data?.image_url;
    if (!url) {
      throw new Error("Invalid upload response");
    }
    return url;
  },
};
